import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { environment } from '../../environments/environment';
import { CustomRouteReuseStrategy } from './route-reuse-strategy';
import { TokenResolverService } from './services/token-resolver.service';
import { importProvidersFrom } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { authErrorInterceptor } from './interceptors/auth-error.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TokenRefreshSchedulerService } from './services/token-refresh-scheduler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    TokenResolverService,
    provideRouter(routes),
    provideHttpClient(withInterceptors([authErrorInterceptor, authInterceptor])),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [TokenRefreshSchedulerService],
      useFactory: (tokenRefreshSchedulerService: TokenRefreshSchedulerService) => () => {
        tokenRefreshSchedulerService.start();
      }
    },
    { provide: 'API_URL', useValue: environment.API_URL },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    importProvidersFrom(MarkdownModule.forRoot())
  ]
};
